import { Component, Prop, Vue } from 'vue-property-decorator'
import SectionInfoColType from '@/modules/globalLocatorModule/sections/info/col-types/section-info-col-type.vue'

@Component({
    components: {
        SectionInfoColType
    }
})
export default class SectionInfoColTypeDate extends Vue {
    @Prop(String) readonly label!: string
    @Prop(String) readonly date!: string
    @Prop(String) readonly colClass!: string
}
